import React, { useEffect, useState, useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import { VscCircleFilled } from 'react-icons/vsc';
import { FiUsers } from 'react-icons/fi';
import { CiClock2 } from 'react-icons/ci';
import { BsPatchExclamation, BsFileCheck } from 'react-icons/bs';
import { Select, SelectItem, Input, Button } from '@nextui-org/react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { postProjectTask, postProjectsTaskNew, postProjectsTaskEdit, postProjectsTaskDelete, getProjectsTeam } from '../../../services/projects';
import Notiflix from 'notiflix';
import { useDispatch } from 'react-redux';
import { setActivePanel, triggerRefreshTasks } from '../../../store/popupState';
import { useParams } from 'react-router-dom';

// TODO: Implement project API services
const getProjectsSingleTask = async (projectId) => {
  return { tasks: [] };
};

const getProjectsTeamData = async (projectId) => {
  return { team: [] };
};

function ProjectTaskComponent(props) {
  const { id } = useParams();
  const [teamData, setTeamData] = useState([]);
  
  // projectId'yi props'tan veya URL'den al
  const projectId = props.projectId || id;
  const taskId = props.taskId;
  

  async function getAll(slug) {
    const get = await getProjectsTeamData(slug)
    setTeamData(get)
  }
  useEffect(() => {
    if (projectId) {
      getAll(projectId)
    }
  }, [projectId])

  //componentType == 0 => Oluştur, componentType == 1 => Düzenle, componentType == 2 => Göster
  const dispatch = useDispatch()
  const [componentType, setComponentType] = React.useState(props.type)
  const [menuSelected, setMenuSelected] = React.useState(0)
  const [colorSelected, setColorSelected] = React.useState(0)
  const [colorColor, setColorColor] = React.useState('text-red-600')
  const [colorText, setColorText] = React.useState('ÖNCELİK')
  const [imready, setImReady] = React.useState(false)
  //After set
  const [t_content, setTaskContent] = React.useState('')
  const [CanEdit, setCanEdit] = React.useState(false)
  const [TaskTitle, setTaskTitle] = React.useState('')
  const sunEditorRef = useRef()
  const [Createdat, setCreatedat] = React.useState('')
  const [TaskStatus, setTaskStatus] = React.useState(0)
  const [CurSureText, setCurSurecText] = React.useState('')
  const [CurUserText, setCurUserText] = React.useState('')
  const [TaskFinished, setTaskFinished] = React.useState('')
  const [TaskPriority, setTaskPriority] = React.useState('')
  const [TaskDeadline, setTaskDeadline] = React.useState('')
  const [editorKey, setEditorKey] = React.useState(0)
  const [selectedUsers, setSelectedUsers] = React.useState([])
  const [projectMembers, setProjectMembers] = React.useState([])
  const [searchQuery, setSearchQuery] = React.useState('')
  const [showDropdown, setShowDropdown] = React.useState(false)

  const list = [
    { value: 1, label: 'Yeni' },
    { value: 2, label: 'İşlemde' },
    { value: 3, label: 'Hazır' },
    { value: 4, label: 'İncelemede' },
    { value: 5, label: 'Tamamlandı' }
  ]

  async function getTaskContent() {
    
    if (!taskId || !projectId) {
      return;
    }
    
    Notiflix.Block.pulse('.right-panel')
    setTimeout(async function () {
      const getit = await postProjectTask({ slug: projectId, taskId: taskId })
      
      if (getit && getit.task && getit.task.length > 0) {
        
        var taskinfo = getit.task[0]
        var userinfo = getit.users && getit.users.length > 0 ? getit.users[0] : null
        setCanEdit(getit.canedit === true)
        
        if (taskinfo) {
          var getcontent = ''
          
          try {
            // tcontent zaten JSON string olarak geliyor, parse et
            const parsedContent = JSON.parse(taskinfo['tcontent'])
            getcontent = parsedContent
          } catch (e) {
            // Eğer parse edilemezse direkt string olarak kullan
            getcontent = taskinfo['tcontent'] || ''
          }
          
          setTaskTitle(taskinfo['tsubject'])
          setTaskContent(getcontent)
          setCreatedat(taskinfo['created_at'])
          setTaskStatus(taskinfo['tstatus'])
          
          // Teslim tarihini set et
          if (taskinfo['deadline_at']) {
            // API'den gelen tarihi datetime-local formatına çevir
            const deadlineDate = new Date(taskinfo['deadline_at'])
            const localDateTime = deadlineDate.toISOString().slice(0, 16)
            setTaskDeadline(localDateTime)
          } else {
            setTaskDeadline('')
          }
          
          
          // SunEditor'ü güncelle
          setTimeout(() => {
            if (sunEditorRef.current && sunEditorRef.current.editor) {
              sunEditorRef.current.editor.setContents(getcontent)
            } else {
            }
            // Force re-render için key'i güncelle
            setEditorKey(prev => prev + 1)
          }, 200)
          
          // Öncelik seçimini ayarla
          const priority = taskinfo['tpriority']
          setColorSelected(priority)
          setTaskPriority(priority)
          
          // Öncelik görselini güncelle
          const priorityLabels = ['', 'Çok Düşük', 'Düşük', 'Normal', 'Yüksek', 'Çok Yüksek']
          const priorityColors = ['', '#cddc39', '#8bc34a', '#039be5', '#ff9800', '#da402f']
          if (priority >= 1 && priority <= 5) {
            setColorText(priorityLabels[priority])
            setColorColor(`text-[${priorityColors[priority]}]`)
          }
        } else {
        }
        // setCurSurecText(t_surec[taskinfo['tstatus']])
        if (userinfo) {
          setCurUserText(userinfo.ufname + ' ' + userinfo.ulname)
        }

        // Atanmış kullanıcıları set et
        if (getit.users && getit.users.length > 0) {
          const assignedUserIds = getit.users.map(user => user.id)
          setSelectedUsers(assignedUserIds)
        } else if (taskinfo.ttarget && Array.isArray(taskinfo.ttarget)) {
          // Eğer ttarget array olarak geliyorsa
          setSelectedUsers(taskinfo.ttarget)
        } else if (taskinfo.ttarget && typeof taskinfo.ttarget === 'string') {
          // Eğer ttarget string olarak geliyorsa (virgülle ayrılmış)
          const userIds = taskinfo.ttarget.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
          setSelectedUsers(userIds)
        } else {
          setSelectedUsers([])
        }

        if (taskinfo['finished_comment']) {
          setTaskFinished(taskinfo['finished_comment'])
        }
        // setTaskPriority(color_list[taskinfo['tpriority']][0])
        setImReady(true)
        Notiflix.Block.remove('.right-panel', 200)
      }
    }, 200)
  }

  React.useEffect(() => {
    
    // Proje üyelerini çek
    fetchProjectMembers()
    
    if (componentType == 0) {
      setImReady(true)
      setTaskStatus(1) // Yeni görev için varsayılan durum
      setTaskContent('') // Yeni görev için boş içerik
      setTaskTitle('') // Yeni görev için boş başlık
      setTaskDeadline('') // Yeni görev için boş teslim tarihi
      setSelectedUsers([]) // Yeni görev için boş kullanıcı seçimi
      return
    }
    if (componentType == 2) {
      return
    }
    if (taskId && projectId) {
      getTaskContent()
    } else {
    }
  }, [taskId, projectId, componentType])

  const handleColor = (opt, title, color) => {
    if (componentType == 2) return
    setColorSelected(opt)
    setColorText(title)
    setColorColor('text-[' + color + ']')
  }

  const handleOptions = (opt) => {
    if (componentType == 2) return
    if (opt == menuSelected) opt = 0
    setMenuSelected(opt)
  }

  const handleTitleChange = (e) => {
    setTaskTitle(e.target.value)
  }

  const handleContentChange = (content) => {
    setTaskContent(content)
  }

  const handleStatusChange = (value) => {
    setTaskStatus(value)
  }

  // Proje üyelerini çek
  const fetchProjectMembers = async () => {
    if (!projectId) return
    
    try {
      const response = await getProjectsTeam({ slug: projectId })
      setProjectMembers(response.usersData || [])
    } catch (error) {
    }
  }

  // Filtrelenmiş üyeleri getir
  const getFilteredMembers = () => {
    if (!searchQuery.trim()) return projectMembers
    return projectMembers.filter(member => 
      `${member.ufname} ${member.ulname}`.toLowerCase().includes(searchQuery.toLowerCase())
    )
  }

  // Kullanıcı ekle
  const addUser = (member) => {
    if (!selectedUsers.includes(member.id)) {
      const newSelectedUsers = [...selectedUsers, member.id]
      setSelectedUsers(newSelectedUsers)
    }
    setSearchQuery('')
    setShowDropdown(false)
  }

  // Kullanıcı kaldır
  const removeUser = (userId) => {
    const newSelectedUsers = selectedUsers.filter(id => id !== userId)
    setSelectedUsers(newSelectedUsers)
  }

  // Seçili kullanıcıları getir
  const getSelectedMembers = () => {
    return projectMembers.filter(member => selectedUsers.includes(member.id))
  }

  // selectedUsers değişimini izle
  React.useEffect(() => {
  }, [selectedUsers])

  const handleDelete = async () => {
    // Düzenleme yetkisi kontrolü
    if (!CanEdit) {
      Notiflix.Notify.failure('Bu görevi silme yetkiniz yok!')
      return
    }

    // Silme onayı
    Notiflix.Confirm.show(
      'Görev Silme',
      'Bu görevi silmek istediğinizden emin misiniz?',
      'Evet',
      'Hayır',
      async () => {
        try {
          Notiflix.Loading.pulse('Görev siliniyor...')
          
          const response = await postProjectsTaskDelete({
            slug: projectId,
            taskid: taskId
          })
          
          Notiflix.Loading.remove()
          Notiflix.Notify.success('Görev başarıyla silindi!')
          
          // Görev listesini yenile
          setTimeout(() => {
            dispatch(triggerRefreshTasks())
          }, 100)
          
          // Panel'i kapat
          dispatch(setActivePanel([0, 0]))
          
        } catch (error) {
          Notiflix.Loading.remove()
          Notiflix.Notify.failure('Görev silinirken hata oluştu!')
        }
      }
    )
  }

  const handleSubmit = async () => {
    // Düzenleme yetkisi kontrolü
    if (componentType === 1 && !CanEdit) {
      Notiflix.Notify.failure('Bu görevi düzenleme yetkiniz yok!')
      return
    }

    // Başlık kontrolü
    if (!TaskTitle.trim()) {
      Notiflix.Notify.failure('Görev başlığı boş olamaz!')
      return
    }

    // İçerik kontrolü - HTML tag'lerini temizleyerek kontrol et
    const cleanContent = t_content.replace(/<[^>]*>/g, '').trim()
    if (!cleanContent) {
      Notiflix.Notify.failure('Görev içeriği boş olamaz!')
      return
    }

    try {
      const taskData = {
        tsubject: TaskTitle.trim(),
        tcontent: t_content,
        tpriority: colorSelected || 1,
        tstatus: TaskStatus || 1,
        curUsers: selectedUsers, // Seçilen kullanıcıların ID'leri
        deadline_at: TaskDeadline ? new Date(TaskDeadline).toISOString().slice(0, 19).replace('T', ' ') : null
      }
      
      
      if (componentType === 1 && taskId) {
        // Mevcut görev düzenleme
        Notiflix.Loading.pulse('Görev güncelleniyor...')
        
        const editData = {
          slug: projectId,
          taskid: taskId,
          ...taskData
        }
        
        const response = await postProjectsTaskEdit(editData)
        
        Notiflix.Loading.remove()
        Notiflix.Notify.success('Görev başarıyla güncellendi!')
      } else {
        // Yeni görev oluşturma
        Notiflix.Loading.pulse('Görev oluşturuluyor...')
        
        const newData = {
          slug: projectId,
          ...taskData
        }
        
        const response = await postProjectsTaskNew(newData)
        
        Notiflix.Loading.remove()
        Notiflix.Notify.success('Görev başarıyla oluşturuldu!')
      }
      
      // Görev listesini yenile (sadece başarılı olduğunda)
      setTimeout(() => {
        dispatch(triggerRefreshTasks())
      }, 100)
      
      dispatch(setActivePanel([0, 0]))
      
    } catch (error) {
      Notiflix.Loading.remove()
      Notiflix.Notify.failure('Görev işlemi sırasında hata oluştu!')
    }
  }

  return (
    <div className="z-50 fixed inset-0 w-full h-full">
      <div 
        onClick={() => dispatch(setActivePanel([0, 0]))} 
        className="bg-black bg-opacity-50 transition-all w-full h-full absolute inset-0 z-50"
      ></div>
      <div 
        onClick={(e) => e.stopPropagation()}
        className="py-5 px-5 bg-white w-[420px] dark:bg-dark-100 top-0 right-0 transition-all h-full fixed z-50 space-y-4 right-panel shadow-2xl"
      >
        <div className="flex space-x-12 justify-between items-center">
          <h1 className="font-normal opacity-60 text-lg">Görev Detayları</h1>
          <button onClick={() => dispatch(setActivePanel([0, 0]))} className=" rounded-full p-2 justify-end opacity-20 hover:bg-stone-300">
            <FaTimes size={23} />
          </button>
        </div>

        <h3 className="text-xs font-semibold text-red-600">İÇERİK</h3>

        <div className="w-full">
          <Input 
            label="Başlık Ekleyin" 
            value={TaskTitle}
            onChange={handleTitleChange}
            isClearable 
            isDisabled={componentType === 1 && !CanEdit}
            style={{ backgroundColor: '#fafafa', borderRadius: '0px' }} 
          />
        </div>

        {imready && (
          <p id="editorjs" style={{ marginTop: 10 }}>
            <SunEditor
              key={editorKey}
              ref={sunEditorRef}
              defaultValue={t_content}
              onChange={handleContentChange}
              readOnly={componentType == 2 ? true : (componentType === 1 && !CanEdit)}
              setOptions={{
                mode: 'balloon',
                minHeight: '200px',
                buttonList: [['fullScreen']]
              }}
            />
          </p>
        )}

        <div className="flex px-3 py-5 border-y border-dashed border-zinc-200">
          <div className="w-full text-center cursor-pointer" onClick={() => handleOptions(1)}>
            <BsPatchExclamation className="mx-auto" size={23} color="#dc2626" />
            <h3 className="text-[11px] mt-2 font-medium text-black">ÖNCELİK</h3>
          </div>

          <div className="w-full text-center cursor-pointer" onClick={() => handleOptions(2)}>
            <FiUsers className="mx-auto" size={20} color="#dc2626" />
            <h3 className="text-[11px] mt-3 font-medium text-black">HEDEF</h3>
          </div>

          <div className="w-full text-center cursor-pointer" onClick={() => handleOptions(3)}>
            <CiClock2 className="mx-auto" size={25} fill="#dc2626" color="#dc2626" />
            <h3 className="text-[11px] mt-2 font-medium text-black">TESLİM</h3>
          </div>

          <div className="w-full text-center cursor-pointer" onClick={() => handleOptions(4)}>
            <BsFileCheck className="mx-auto" size={23} color="#dc2626" />
            <h3 className="text-[11px] mt-3 font-medium text-black">DURUM</h3>
          </div>
        </div>

        <div id="mainarea">
          {menuSelected == 1 && (
            <div className="flex border-b border-dashed border-zinc-200 bg-white dark:bg-dark-100">
              <h3 className={`w-1/5 text-center self-center text-xs font-medium ${colorColor}`}>{colorText}</h3>
              <div className="w-4/5 flex items-center content-center min-h-[80px] px-5">
                <VscCircleFilled
                  onClick={() => handleColor(1, 'Çok Düşük', '#cddc39')}
                  className="cursor-pointer rounded-full text-[60px] hover:text-[70px] transition-all duration-200"
                  color={colorSelected == 0 || colorSelected == 1 ? '#cddc39' : '#ccc'}
                />
                <VscCircleFilled
                  onClick={() => handleColor(2, 'Düşük', '#8bc34a')}
                  className="cursor-pointer rounded-full text-[60px] hover:text-[70px] transition-all duration-200"
                  color={colorSelected == 0 || colorSelected == 2 ? '#8bc34a' : '#ccc'}
                />
                <VscCircleFilled
                  onClick={() => handleColor(3, 'Normal', '#039be5')}
                  className="cursor-pointer rounded-full text-[60px] hover:text-[70px] transition-all duration-200"
                  color={colorSelected == 0 || colorSelected == 3 ? '#039be5' : '#ccc'}
                />
                <VscCircleFilled
                  onClick={() => handleColor(4, 'Yüksek', '#ff9800')}
                  className="cursor-pointer rounded-full text-[60px] hover:text-[70px] transition-all duration-200"
                  color={colorSelected == 0 || colorSelected == 4 ? '#ff9800' : '#ccc'}
                />
                <VscCircleFilled
                  onClick={() => handleColor(5, 'Çok Yüksek', '#da402f')}
                  className="cursor-pointer rounded-full text-[60px] hover:text-[70px] transition-all duration-200"
                  color={colorSelected == 0 || colorSelected == 5 ? '#da402f' : '#ccc'}
                />
              </div>
            </div>
          )}

          {menuSelected === 2 && (
            <div className="flex flex-col border-b border-dashed border-zinc-200 bg-white dark:bg-dark-100 p-4">
              <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Görev Atanacak Kişiler</h3>
              
              {/* Tag-based Input Container */}
              <div className="relative">
                {/* Selected Users Tags */}
                {getSelectedMembers().length > 0 && (
                  <div className="flex flex-wrap gap-2 mb-3 p-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-800">
                    {getSelectedMembers().map((member) => (
                      <div
                        key={member.id}
                        className="flex items-center space-x-2 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-3 py-1 rounded-full text-sm"
                      >
                        <div className="h-5 w-5 rounded-full bg-blue-500 flex items-center justify-center text-white text-xs font-semibold">
                          {member.ufname?.charAt(0)}{member.ulname?.charAt(0)}
                        </div>
                        <span>{member.ufname} {member.ulname}</span>
                        {!(componentType === 1 && !CanEdit) && (
                          <button
                            onClick={() => removeUser(member.id)}
                            className="ml-1 hover:bg-blue-200 dark:hover:bg-blue-800 rounded-full p-0.5"
                          >
                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Search Input */}
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Kişi ara veya seç..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value)
                      setShowDropdown(true)
                    }}
                    onFocus={() => setShowDropdown(true)}
                    disabled={componentType === 1 && !CanEdit}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  
                  {/* Dropdown Arrow */}
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                    <svg 
                      className={`w-4 h-4 text-gray-400 transition-transform ${showDropdown ? 'rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>

                {/* Dropdown List */}
                {showDropdown && getFilteredMembers().length > 0 && (
                  <div className="absolute z-10 w-full mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    {getFilteredMembers()
                      .filter(member => !selectedUsers.includes(member.id))
                      .map((member, index) => (
                        <div
                          key={member.id || index}
                          onClick={() => addUser(member)}
                          className="flex items-center space-x-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer"
                        >
                          <div className="h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center text-white text-xs font-semibold">
                            {member.ufname?.charAt(0)}{member.ulname?.charAt(0)}
                          </div>
                          <span className="text-sm text-gray-700 dark:text-gray-300">
                            {member.ufname} {member.ulname}
                          </span>
                        </div>
                      ))}
                  </div>
                )}

                {/* No Results */}
                {showDropdown && searchQuery && getFilteredMembers().filter(member => !selectedUsers.includes(member.id)).length === 0 && (
                  <div className="absolute z-10 w-full mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg p-3">
                    <p className="text-sm text-gray-500 dark:text-gray-400">Arama sonucu bulunamadı</p>
                  </div>
                )}
              </div>

              {/* Click outside to close dropdown */}
              {showDropdown && (
                <div 
                  className="fixed inset-0 z-0" 
                  onClick={() => setShowDropdown(false)}
                />
              )}
            </div>
          )}
          {menuSelected == 3 && (
            <div className="flex border-b border-dashed border-zinc-200 p-4 bg-white dark:bg-dark-100">
              <div className="w-full">
                <Input 
                  type="datetime-local"
                  label="Teslim Tarihi"
                  placeholder="Tarih seçiniz"
                  className="w-full"
                  value={TaskDeadline}
                  onChange={(e) => setTaskDeadline(e.target.value)}
                  isDisabled={componentType === 1 && !CanEdit}
                />
              </div>
            </div>
          )}

          {menuSelected == 4 && (
            <div className="flex border-b border-dashed border-zinc-200 bg-white dark:bg-dark-100">
              <Select 
                items={list} 
                label="Durum Seçiniz" 
                placeholder="Güncel Durum" 
                className="w-full mb-5"
                isDisabled={componentType === 1 && !CanEdit}
                selectedKeys={TaskStatus ? [TaskStatus.toString()] : []}
                onSelectionChange={(keys) => {
                  const selectedKey = Array.from(keys)[0]
                  handleStatusChange(parseInt(selectedKey))
                }}
              >
                {(item) => <SelectItem key={item.value}>{item.label}</SelectItem>}
              </Select>
            </div>
          )}
        </div>

        <div className="space-y-2">
          <Button 
            className="bg-[#2f73da] text-white text-sm w-full" 
            variant="solid"
            onClick={handleSubmit}
            disabled={!TaskTitle.trim() || !t_content.trim() || (componentType === 1 && !CanEdit)}
          >
            {componentType === 1 ? (CanEdit ? 'Güncelle' : 'Düzenleme Yetkisi Yok') : 'Gönder'}
          </Button>
          
          {componentType === 1 && CanEdit && (
            <Button 
              className="bg-red-600 text-white text-sm w-full" 
              variant="solid"
              onClick={handleDelete}
            >
              Görevi Sil
            </Button>
          )}
        </div>
        <div className="w-full border-t opacity-50 border-dashed border-zinc-300"></div>
      </div>
    </div>
  )
}
export default ProjectTaskComponent
